export default "__VITE_ASSET__CLOHHF8V__"